<mat-card style="">
  <mat-icon color="warn" style="margin-left:auto; margin-right:5px ;float: right;cursor: pointer;"
    (click)="closeDialog()">close</mat-icon>
  <!-- <span [innerHtml]="notice.message"></span> -->
  <app-html-view [value]="notice.message"></app-html-view>
</mat-card>